// src/pages/Brand/components/CategoryFilter.js
import React from 'react';
import BrandSearch from './BrandSearch';

/**
 * 카테고리 필터 컴포넌트
 * 브랜드 카테고리 필터링 및 검색 기능을 제공합니다.
 */
const CategoryFilter = ({ currentCategory, onCategoryChange, onSearch, onReset }) => {

  return (
    <BrandSearch
      currentCategory={currentCategory}
      onSearch={onSearch}
      onReset={onReset}
    />
  );
};

export default CategoryFilter;
